<!-- non-score popup -->
<div class="subcription-pop-wrap" *ngIf="examtype != 'SCHOLARSHIPTEST'">
    <a  (click)="close()" class="link UNFAPP-crossbtn-cont"><img src="assets/img/filter-close-icon.png" class="icon UNFAPP-crossbtn-img" /></a>
    <div class="pophdr-area">
        <h3 ><b>Uh ho!</b></h3>
            <h3><b>You can’t access this content</b></h3>
            <img src="assets/img/animation_Inactive_lock_icon.svg" alt="" class="UNFAPP-extire-timeimg"/>
    </div>

    <h4 class="UNFAPP-trialblueheading">Your subscription is inactive.</h4>
    <!--<p class="UNFAPP-mesagetext">{{message}}</p>-->
    <h5 class="UNFAPP-textoff" >You have an outstanding amount to be paid for the package
        you have subscribed.</h5>
    <div class="popactn-area">
        <button (click)="redirectSubscription()"class="btn UNFAPP-asmnt-blue-hdrbtn" *ngIf="!examtype">Go to My subscriptions</button>


    </div>
</div>

<!-- score popup -->
<div class="subcription-pop-wrap" *ngIf="examtype == 'SCHOLARSHIPTEST'">
    <a  (click)="activeModal.close()" class="link UNFAPP-crossbtn-cont"><img src="assets/img/filter-close-icon.png" class="icon UNFAPP-crossbtn-img" /></a>
    <div class="pophdr-area">        
        <h3 class="UNFAPP_trialheading">India’s no.1 Scholarship Test</h3>
            <img src="assets/img/expire-score.png" alt="" class="UNFAPP-extire-timeimg" />
    </div>
    
    <h4 class="UNFAPP-trialblueheading">A little something, just for you! </h4>
    <!--<p class="UNFAPP-mesagetext">{{message}}</p>-->
    <h5 class="UNFAPP-textoff"><span>FLAT 10% OFF</span> on Purchasing SCORE Package</h5>
    <div class="UNFAPP-coupenboxcont">
        <img src="assets/img/cuponcode-icon.svg" alt="" class="UNFAPP-gifticonimg" />
        <div class="UNFAPP-coupen-innertext">Coupon code: {{couponCode}}</div>
        <button class="UNFAPP-copybutton" (click) = "copyCoupon(couponCode)"><img src="assets/img/Copy-icon.svg" alt="" class="UNFAPP-copyicon" /><span class="UNFAPP-tooltip" *ngIf="showCoupon">Copied</span></button>
    </div>
    <div class="popactn-area">
        <button (click)="redirectSubscription()" class="btn UNFAPP-asmnt-blue-hdrbtn">REGISTER at {{value | currency:"&#8377;"}}</button>        
    </div>
</div>

